import { Chip } from '@mui/material';
import React from 'react';
import type { TimeRangeOption } from '../config/plotTypes';

export interface TimeRangePillProps {
  option: TimeRangeOption;
  onSelect: (option: TimeRangeOption) => void;
  isSelected: boolean;
}

const timeUnitToFrenchLabel: Record<TimeRangeOption['unit'], [string, string]> =
  {
    minute: ['minute', 'minutes'],
    hour: ['heure', 'heures'],
    day: ['jour', 'jours'],
    week: ['semaine', 'semaines'],
    month: ['mois', 'mois'],
    year: ['an', 'ans'],
  };

export const TimeRangePill: React.FC<TimeRangePillProps> = ({
  option,
  onSelect,
  isSelected,
}) => {
  const [singular, plural] = timeUnitToFrenchLabel[option.unit];

  return (
    <Chip
      label={`${option.quantity} ${option.quantity > 1 ? plural : singular}`}
      color={isSelected ? 'primary' : 'default'}
      onClick={() => onSelect(option)}
    />
  );
};
